module.exports = __webpack_public_path__ + "61453797745ad4bb6f09848f40ca1234.png";